
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press-room/[slug]",
      function () {
        return require("private-next-pages/press-room/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/press-room/[slug]"])
      });
    }
  